import React from 'react';
import MultipleFeaturedCouponsAction
  from '@/Pages/Categories/Assets/MultipleFeaturedCouponsAction/MultipleFeaturedCouponsAction';

const FeaturedCouponsBottomPanel = ({ handleCheckAll, checked, parentCheckbox }) => {
  return (
    <tfoot className='border-t'>
    <tr>
      <td className='px-1 pt-5 pb-4 w-1'>
        <input type='checkbox' onChange={handleCheckAll} ref={parentCheckbox} defaultChecked={false} />
      </td>
      <td>
        <MultipleFeaturedCouponsAction checked={checked} />
      </td>
    </tr>
    </tfoot>
  );
};

export default FeaturedCouponsBottomPanel;
